<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="openMateDeliveryWrite">
              출고추가
            </el-button>
            <el-button type="danger" icon="el-icon-delete-solid" @click="deleteRow">
              출고삭제
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="출고기간" label-width="100px">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                  <el-col :span="1" style="text-align: start;">-</el-col>
                  <el-col :span="12">
                    <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="출고구분" label-width="80px">
                <el-select v-model="form.outType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['outType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-row>
                <el-form-item label="지역/센터" label-width="100px">
                  <el-col :span="10">
                    <el-select v-model="form.catId" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['catId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="14">
                    <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subCatId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="제조사" label-width="100px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="제품군" label-width="80px">
                <el-col :span="10">
                  <el-select v-model="form.itemGroup" @change="onItemGroupChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['itemGroup']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="14">
                  <el-select v-model="form.subItemGroup" v-show="changeItemGroupShow">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['subItemGroup']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="품번" label-width="70px">
                <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="처리상태" label-width="80px">
                <el-select v-model="form.outStatus">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['outStatus']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                enableRangeSelection="true"
                @cell-clicked="onCellClicked"
                @grid-ready="onReadyMain" />
          </div>

          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
            />
          </div>
        </div>
      </div>
    </div>


    <el-form size="mini" >
      <div>
        <el-form-item label-width="0px" style="float: right;">
          <el-button v-show="updateButtonShow" type="primary" style="float: right;" icon="el-icon-files" @click="updateCount()">
            수정
          </el-button>
        </el-form-item>
      </div>
    </el-form>

    <mate-Delivery-Info ref="mateDeliveryInfo" :mateDeliveryDetail="mateDeliveryDetail" style="height: 100%"/>
  </div>
</template>

<script>
import mixin from "@/mixin/lucoms";
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import MateDeliveryInfo from '@/components/WorkMng/MateDeliveryInfo.vue';
import MateDeliveryWrite from '@/components/LucomsModal/MateDeliveryWrite.vue';

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [mixin],
  props: {
  },
  components: {MateDeliveryInfo},
  data() {
    return {
      data: [],
      excelData: [],
      form: {
        companyId : '',
        startDt: this.$moment().format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        outType : '',            // 출고구분
        maker : '',              // 제조사
        catId : '',              // 지역
        subCatId: '',            // 지역 상세
        itemGroup : '',          // 제품군
        subItemGroup: '',        // 제품군 상세
        asAgentId : '',
        itemCd : '',             // 품번
        outStatus : '',          // 처리상태
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      },
      combos: {
        'maker' : [],            //제조사
        'outType' : [],          //출고구분
        'itemGroup' : [],        //제품군
        'subItemGroup' : [],     //sub제품군
        'catId' : [],            //지역센터
        'subCatId' : [],         //지역상세
        'outStatus' : [],        //처리상태
        'requestType' : [],      //자재요청구분 (그리드에서 출고구분에 사용, getOutType() 참고.)

      },
      changeCatIdShow : false,
      changeItemGroupShow : false,
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 10px; width: 100%;height: 550px; min-height:100px;',
      defaultColDef: {
        resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        excelStyles: [
          { id: 'numberType',numberFormat: {format: '0',}},
          { id: 'stringType', dataType: 'String'},
          { id: 'dateType', dataType: 'DateTime'},
        ],
      },
      columnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      mateDeliveryDetail: [],
      updateButtonShow : true
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'출고일자', field:'outDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'센터입고일', field:'inDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'출고번호', field:'outItemId', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'출고구분', field:'outTypeNm', width:120, cellStyle:{textAlign: 'left'},
          /*valueGetter: (params) => {
            return this.getOutType(params)
          }*/
        },
        {headerName:'출고센터', field:'inAsAgentNm', width:120, cellStyle:{textAlign: 'left'}},
        {headerName:'제조사', field:'makerNm', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:110, cellStyle:{textAlign: 'left'}},
        {headerName:'품번', field:'itemCd', width:240},
        {headerName:'품명', field:'itemNm', width:250},
        {headerName:'양품출고', field:'inGoodQty', width:110, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
        {headerName:'불량출고', field:'badQty', width:110, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
        {
          headerName: '선택',
          field: 'chk',
          width: 80,
          cellRenderer: 'checkBox',
          cellRendererParams: (params) => {
            return {trueValue: 'Y', falseValue: 'N', disable: (parseInt(params.data.itemId) === '') || (params.data.outType) === 'Order' || params.data.inDt !== null }
          }
        },
      ];
    },
    createExcelColumnDefs() {
      const that = this;
      this.excelColumnDefs = [
        {headerName:'출고일자', field:'outDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'센터입고일', field:'inDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'출고번호', field:'outItemId', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'출고구분', field:'outTypeNm', width:120, cellStyle:{textAlign: 'left'}},
        {headerName:'출고센터', field:'inAsAgentNm', width:120, cellStyle:{textAlign: 'left'}},
        {headerName:'제조사', field:'makerNm', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:110, cellStyle:{textAlign: 'left'}},
        {headerName:'품번', field:'itemCd', width:240, cellClass: 'stringType'},
        {headerName:'품명', field:'itemNm', width:250, cellClass: 'stringType'},
        {headerName:'규격', field:'itemSpec', width:250, cellClass: 'stringType'},
        {headerName:'이평단가', field:'unitPrice1', width:110, cellStyle:{textAlign: 'right'}, cellClass: 'numberType',
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
        {headerName:'공급단가', field:'unitPrice2', width:110, cellStyle:{textAlign: 'right'}, cellClass: 'numberType',
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
        {headerName:'양품출고', field:'inGoodQty', width:110, cellStyle:{textAlign: 'right'}, cellClass: 'numberType',
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
        {headerName:'이평금액', field:'unitPrice1Amt', width:110, cellStyle:{textAlign: 'right'}, cellClass: 'numberType',
          valueGetter: (params) => {
            return `${this.getNumberFormat(parseInt(params.data.inGoodQty) * parseInt(params.data.unitPrice1)) || 0}`;
          }
        },
        {headerName:'양품출고금액', field:'goodAmt2', width:110, cellStyle:{textAlign: 'right'}, cellClass: 'numberType',
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
        {headerName:'불량출고', field:'badQty', width:110, cellStyle:{textAlign: 'right'}, cellClass: 'numberType',
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
        {headerName:'불량출고금액', field:'badAmt2', width:110, cellStyle:{textAlign: 'right'}, cellClass: 'numberType',
          valueFormatter: (params) => {
            return this.getNumberFormat(params.value);
          }
        },
      ];
    },
    // onSelectionChangedSub(event) {
    //   this.gridApiSub = this.mainGridOptions.api;
    //   const voRow = this.gridApiSub.getSelectedRows() //선택된 Row
    //   this.mateDeliveryDetail = []; // 초기화
    //   this.mateDeliveryDetail = voRow[0];
    // },
    onCellClicked(params) {
      this.mateDeliveryDetail = []; // 초기화
      this.mateDeliveryDetail = params.data;
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')
      const vForm = {
        companyId : this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        outType : this.form.outType,             // 입고구분
        maker : this.form.maker,                 // 제조사
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,          // 제품군
        subItemGroup: '',                        // 제품군 상세
        asAgentId : this.form.asAgentId,
        itemCd : this.form.itemCd,               // 품번
        outStatus : this.form.outStatus,         // 처리상태
        sortType : this.form.sortType,           // 승인/정산처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$http.post(_url("/api/workMng/mateDelivery/list"), vForm, {timeout: 60000*30})
          .then(response => {
            this.data = response.data
            this.changeData();
          }).finally(() => {
        this.$refs.mateDeliveryInfo.dataClear();
        this.$store.commit('finish')
      });
    },
    updateCount(){
      if(!this.$refs.mateDeliveryInfo.validation()) return;

      this.$swal({
        type: 'info',
        text: `입고 수량을 수정 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          let mateDeliveryInfo = JSON.parse(JSON.stringify(this.$refs.mateDeliveryInfo.form));
          mateDeliveryInfo.outDt = mateDeliveryInfo.outDt + 'T00:00:00'
          this.$store.commit('loading')
          this.$http.get(`/api/asMng/call/config`, {params: {keyPath: 'System.MainAsAgentId'}})
              .then(response => {
                mateDeliveryInfo.asAgentId = response.data[0].configValue
                this.$http.post(`/api/workMng/mateDelivery/update`, mateDeliveryInfo).then((response) => {
                  if (response.data) {
                    this.$swal({type: 'info', text: '저장되었습니다.'});
                  }
                  this.goOpen();
                }).catch((e) => {
                  this.$swal({type: 'error', text: e.response.data.message});
                }).finally(() => {
                  this.$store.commit('finish')
                });

              });
        }
      });
    },
    deleteRow() {
      let vm = this;
      let list = this.data.filter(v => v.chk === 'Y')
      vm.result = [];

      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 삭제 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            vm.result = list;
            this.$http.post(_url(`/api/workMng/mateDelivery/delete`), vm.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '입고 삭제를 하였습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({ type: 'success', text: '입고 삭제를 실패 하였습니다.' })
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '삭제할 항목을 선택하세요.' });
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/mateDelivery/init`)
          .then(response => {
            this.combos['maker'] = response.data.maker;
            this.combos['outType'] = response.data.outType;
            this.combos['catId'] = response.data.catId;              //지역센터
            this.combos['itemGroup'] = response.data.itemGroup;      //제품군
            this.combos['outStatus'] = response.data.outStatus;      //제품군
            this.combos['requestType'] = response.data.requestType;  //자재요청구분
          }).finally(() => {
            // this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
      this.createExcelColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    onItemGroupChange(param){
      this.form.subItemGroup = '';
      if(param === '') this.changeItemGroupShow =  false;
      else{
        this.changeItemGroupShow =  true
        // 제품군
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subItemGroup'] = response.data || []
                  });
            });
      }
    },
    /**
     * 입고추가 팝업 오픈
     */
    openMateDeliveryWrite() {
      const vm = this

      this.$modal.open({
        component: MateDeliveryWrite,
        parent: this,
        props: {
        },
        events: {
          close(data) {
          },
        }
      });
    },
    // changeData 로 변경 함.
    // getOutType(params){
    //   var result = '';
    //   var val = params.data;
    //
    //   let filterOutType = this.combos['outType'].filter(y => y.key === val.outType);
    //   if(filterOutType[0] === undefined){
    //     let filterRequestType = this.combos['requestType'].filter(y => y.key === val.outType);
    //     result = filterRequestType[0].value;
    //   } else {
    //     result = filterOutType[0].value;
    //   }
    //   return result;
    // },
    /* data customize */
    changeData(){
      this.data.map((x, i) => {
        let filterOutType = this.combos['outType'].filter(y => y.key === x.outType);

        if(filterOutType[0] === undefined){
          let filterRequestType = this.combos['requestType'].filter(y => y.key === x.outType);
          x.outTypeNm = filterRequestType[0].value;
        } else {
          x.outTypeNm = filterOutType[0].value;
        }
      })
    },
    getConfigValue() {
      this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
          .then(response => {
            this.form.asAgentId = response.data[0].configValue;
          });
    },
    excelDown(){
      this.$store.commit('loading')

      const vForm = {
        companyId : this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        outType : this.form.outType,             // 입고구분
        maker : this.form.maker,                 // 제조사
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,          // 제품군
        subItemGroup: '',                        // 제품군 상세
        asAgentId : this.form.asAgentId,
        itemCd : this.form.itemCd,               // 품번
        outStatus : this.form.outStatus,         // 처리상태
        sortType : this.form.sortType,           // 승인/정산처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$http.post(_url("/api/workMng/mateDelivery/getExcelList"), vForm)
          .then(response => {
            console.log('response.data', response.data)
            this.excelData = response.data.map(x => {
              x.unitPrice1Amt = x.inGoodQty * x.unitPrice1
              x.outDt = x.outDt !==null ? this.$moment(x.outDt).format('YYYY-MM-DD') : ''
              x.inDt = x.inDt !==null ? this.$moment(x.inDt).format('YYYY-MM-DD') : ''

              let filterOutType = this.combos['outType'].filter(y => y.key === x.outType);

              if(filterOutType[0] === undefined){
                let filterRequestType = this.combos['requestType'].filter(y => y.key === x.outType);
                x.outTypeNm = filterRequestType[0].value;
              } else {
                x.outTypeNm = filterOutType[0].value;
              }

              return x
            });
            console.log('this.excelData', this.excelData)

          }).finally(() => {
        this.$store.commit('finish');
        var params = {
          fileName : "자재출고처리"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.getConfigValue();
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>